/* Angular Component */
import { KeepOriginalOrder } from "../../../../domain/common/ui-utils";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ExternalMAMDropBucket } from "../../../../domain/external-mam/external-mam-gateway-provider";

// import { ActivatedRoute, Params, Router } from '@angular/router';
// import { ExternalMAMServiceProvider } from 'app/js/src/domain/external-mam/external-mam-service-provider';
// import { IExternalMAMRepository } from 'app/js/src/domain/external-mam/i-external-mam.repository';
@Component({
  selector: "external-mam-providers-setup-step-one",
  templateUrl: "./external-mam-providers-setup-step-one.component.html",
  styleUrls: ["./external-mam-providers-setup-step-one.component.scss"],
})
export class ExternalMAMProvidersSetupStepOneComponent {
  internalLoginData: Record<string, string> = {};
  public KeepOriginalOrder = KeepOriginalOrder;
  @Input()
  loginData: Record<string, string> = {};

  @Input()
  serviceName: string;

  @Input()
  gatewayName: string;

  @Input()
  autoPull: boolean;

  @Input()
  isActive: boolean;

  @Input()
  languages: { name: string; code: string }[];

  @Input()
  selectedLanguages: string[];

  @Input()
  selectedSubtitles: string[];

  @Input()
  loginOk: boolean;

  @Input()
  providerType: number;

  @Input()
  dropBucket: ExternalMAMDropBucket;

  @Output()
  selectedLanguagesChanged = new EventEmitter();

  @Output()
  selectedSubtitlesChanged = new EventEmitter();

  @Output()
  loginFieldsUpdated: EventEmitter<{ key: string; value: string }> =
    new EventEmitter();

  @Output()
  generalFieldUpdated: EventEmitter<{ key: string; value: string }> =
    new EventEmitter();

  @Output()
  startTestConnnection = new EventEmitter();

  @Output()
  providerStateUpdated: EventEmitter<boolean> = new EventEmitter();

  @Output()
  dropBucketFieldUpdated: EventEmitter<{ key: string; value: string }> =
    new EventEmitter();

  // serviceProvider: ExternalMAMServiceProvider = null;
  // steps: Array<string> = ["connect platform","map fields"];
  // constructor(
  //     private _repository: IExternalMAMRepository,
  //     private route: ActivatedRoute,
  //     private router: Router)
  // {

  // }

  stringifyKey(key: unknown): string {
    return String(key);
  }

  ngOnInit(): void {
    this.internalLoginData = this.loginData ? { ...this.loginData } : {};
  }
  updateLogin(value, key) {
    this.loginFieldsUpdated.emit({ key: key, value: value.target.value });
  }
  updateLoginDirect(key: string, value: string) {
    this.loginFieldsUpdated.emit({ key, value });
  }
  updateGeneral(key, value) {
    this.generalFieldUpdated.emit({ key: key, value: value });
  }
  updateGeneralFromInput(key: string, event: Event): void {
    this.updateGeneral(key, (event.target as HTMLInputElement).value);
  }
  languagesChange(values) {
    this.selectedLanguagesChanged.emit(values);
  }
  subtitlesChange(values) {
    this.selectedSubtitlesChanged.emit(values);
  }
  testConnection() {
    if (!this.loginOk) {
      if (Object.values(this.loginData).every((x) => x)) {
        this.startTestConnnection.emit();
      }
    }
  }
  TestConnectionButtonText() {
    return this.loginOk ? "Connection Succsseful!" : "Test Connection";
  }
  updateState(state: boolean) {
    this.providerStateUpdated.emit(state);
  }
  get isDalet(): boolean {
    return this.providerType === 2;
  }
  updateDropBucketField(key: string, value: string) {
    this.dropBucketFieldUpdated.emit({ key, value });
  }
}
